"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var collapsing_facet_1 = require("./collapsing_facet");
var select_facet_option_1 = require("./select_facet_option");
var search_filters_1 = require("./search_filters");
// Corresponds to `.facet__option:nth-child(n+6)` in facets.scss
var COLLAPSE_THRESHOLD = 6;
var SelectFacet = function (_a) {
    var filter = _a.filter;
    return (React.createElement(collapsing_facet_1.default, { count: filter.options.length, countThreshold: COLLAPSE_THRESHOLD, classPrefix: "facet" },
        React.createElement("div", { className: "facet__heading" }, filter.name),
        React.createElement("ul", { className: "facet__options" }, filter.options.map(function (option, idx) { return (React.createElement(select_facet_option_1.default, { key: idx, option: option, checkbox: filter.widgetType === search_filters_1.WidgetType.CHECKBOX })); }))));
};
exports.default = SelectFacet;
//# sourceMappingURL=select_facet.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/select_facet.js
// module id = DTHl
// module chunks = 0 1 2 3 9 10 14 20